import { IsNotEmpty, IsUUID, IsBoolean } from 'class-validator';

export class CreateVacationUnitDto {
  @IsUUID()
  @IsNotEmpty()
  unit_id: string;

  @IsBoolean()
  @IsNotEmpty()
  include_children_units: boolean;
}
